export const carouselInicio = [
   {
      "imagen" : "videos/img_declara.gif",
   },  
 
 
]